"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWT_ERROR = void 0;
var JWT_ERROR;
(function (JWT_ERROR) {
    JWT_ERROR["BAD_JWT"] = "BAD_JWT";
    JWT_ERROR["BAD_JWT_REFRESH"] = "BAD_JWT_REFRESH";
})(JWT_ERROR = exports.JWT_ERROR || (exports.JWT_ERROR = {}));
